{
  "title": "Charts",
  "actions": {
    "save": "Save chart",
    "update": "Refresh",
    "saveChanges": "Save",
    "revert": "Discard",
    "saveAsNew": "Save as a copy"
  },
  "tabs": {
    "label": "Charts",
    "draft": "New chart",
    "saveAction": "Save chart",
    "newAction": "New chart",
    "delete": "Delete the chart “{{name}}”",
    "unsaved": "unsaved changes",
    "rename": "Rename",
    "share": "Share with colleagues",
    "unshare": "Stop sharing",
    "remove": "Delete",
    "shared": "Shared by {{owner}}",
    "renameLabel": "Chart name"
  },
  "panel": {
    "title": "Device selection",
    "from": "Start date",
    "to": "End date",
    "search": "Search devices",
    "all": "All",
    "selected": "{{count}} selected",
    "clear": "Clear",
    "apply": "Apply",
    "noCategory": "No category",
    "notFound": "Nothing found",
    "noIndicators": "This site has no indicators yet",
    "pickDate": "Pick a date",
    "dateInvalid": "Invalid date — DD.MM.YYYY",
    "limit": "A chart can hold at most {{max}} indicators",
    "expand": "Expand {{name}}",
    "collapse": "Collapse {{name}}"
  },
  "periods": {
    "label": "Period",
    "1d": "1 DAY",
    "7d": "7 DAYS",
    "30d": "30 DAYS",
    "all": "All",
    "custom": "Custom"
  },
  "summary": "{{from}} - {{to}}  -  {{count}} measurements",
  "views": {
    "label": "View",
    "chart": "Chart",
    "table": "Table"
  },
  "legend": {
    "updated": "Last update: {{time}}",
    "toggle": "Show or hide {{name}}",
    "missing": "{{count}} indicator(s) not found"
  },
  "kpi": {
    "min": "Min",
    "max": "Max",
    "avg": "Avg"
  },
  "thresholds": {
    "warning": "Warning",
    "danger": "Danger limit"
  },
  "table": {
    "time": "Time",
    "status": "Status"
  },
  "status": {
    "normal": "Normal",
    "m1": "Warning",
    "m2": "Danger"
  },
  "empty": {
    "title": "No indicators selected",
    "text": "Tick indicators in the list on the right and press “Apply”.",
    "noData": "No measurements in the selected period",
    "noDataText": "Try another period."
  },
  "save": {
    "title": "Save chart",
    "name": "Chart name",
    "nameHint": "The name is shown on the tab bar above",
    "series": "Selected devices ({{count}})",
    "seriesSearch": "Search the selection",
    "seriesHint": "Scroll the list or search it. Chart colours may repeat",
    "remove": "Remove “{{name}}”",
    "keepPeriod": "Save the period too",
    "allPeriod": "Whole period",
    "share": "Share with colleagues",
    "shareHint": "Other users of the site will see the chart too",
    "saved": "Chart saved",
    "savedText": "“{{name}}” was added to the tab bar",
    "updated": "Changes saved",
    "nameTaken": "A chart with this name already exists",
    "nameRequired": "Enter a chart name",
    "noSeries": "Select at least one indicator",
    "cancel": "Cancel",
    "submit": "Save"
  },
  "delete": {
    "title": "Delete the chart?",
    "text": "The chart “{{name}}” will be deleted.",
    "confirm": "Delete",
    "done": "Chart deleted"
  },
  "rename": {
    "saved": "Renamed"
  },
  "share": {
    "on": "Chart shared",
    "off": "Sharing stopped"
  },
  "refreshed": "Data refreshed",
  "error": {
    "load": "Could not load the data",
    "retry": "Try again",
    "generic": "Something went wrong"
  },
  "common": {
    "close": "Close",
    "cancel": "Cancel"
  }
}
